import { defineComponent as _defineComponent } from 'vue'
interface Props {
  label: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LabelledHR',
  props: {
    label: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})